<template>
  <cw-select
      v-model="value"
      :list="mapData(list)"
      label="name"
      value="value"
      :class="classname"
      :disabled="disabled"
      :placeholder-params="placeholder"
      :keeps-params="10"
      :is-concat="false"
      :is-multiple="isMultiple"
      :is-right="false"
      :allow-create="false"
      @change="selectChange"
    />
</template>

<script>
  import CwSelect from './select.vue'

  export default {
      name:'insuplc',
      components: {
          CwSelect
      },
      props: {
        isMultiple: {
            type: Boolean,
            default: false
        },
        defaultValue: {
        },
        disabled: {
          type: Boolean
        },
        classname: {
          type: Object
        },
        placeholder: {
          type: String
        },
        list: {
          type:Array
        }
      },
      watch: {
        defaultValue:{
          handler(newVal) {
            this.value = newVal
          },
          immediate: true,
          deep: true
        }
      },
      data() {
          return {
            value:this.defaultValue,
            // list:[]
          };
      },
      mounted() {
      },
      methods: {
          mapData(list){
            return list.map(item => {
              item.label = item.name
              item.value = item.id
              return item
            })
          },

          selectChange(val) {
              this.$emit('change', {value:val})
          }
      }
  };
</script>
